if (!customElements.get('dbtfy-product-option-modals')) {
  customElements.define(
    'dbtfy-product-option-modals',
    class DbtfyVariantModalContent extends HTMLElement {
      constructor() {
        super();
        this.modalWidth = this.dataset.modalWidth;
        this.modal = null;
        this.option = this.dataset.option;
        this.product = this.dataset.product;

        this.optionModalInit();
      }
      optionModalInit() {
        const options = Array.from(document.querySelectorAll('dbtfy-option-modal'));

        const match = options.find((option) => {
          if (this.option !== option.dataset.option) return false;

          const visibility = option.dataset.visibility;
          const productList = option.dataset.productList?.split(',') || [];

          return visibility === 'all' || (visibility === 'product' && productList.includes(this.product));
        });

        if (match) {
          this.init(match);
        } else {
          this.remove();
        }
      }

      init(option) {
        this.appendChild(option.querySelector('.dbtfy-product-option-modal__value').cloneNode(true));

        const imageNodes = option.querySelectorAll('.dbtfy-option-modal__image');
        const imagesContainer = this.querySelector('.dbtfy-product-option-modals__images');

        if (imagesContainer && imageNodes.length) {
          imageNodes.forEach((node) => {
            imagesContainer.appendChild(node.cloneNode(true));
          });
        }

        const titleNodes = option.querySelectorAll('.dbtfy-option-modal__title');
        const titleContainer = this.querySelector('.dbtfy-product-option-modals__title');

        if (titleContainer && titleNodes.length) {
          titleNodes.forEach((node) => {
            titleContainer.appendChild(node.cloneNode(true));
          });
        }

        const descriptionNodes = option.querySelectorAll('.dbtfy-option-modal__description');
        const descriptionContainer = this.querySelector('.dbtfy-product-option-modals__description');

        if (descriptionContainer && descriptionNodes.length) {
          descriptionNodes.forEach((node) => {
            descriptionContainer.appendChild(node.cloneNode(true));
          });
        }

        this.querySelectorAll('.dbtfy-product-option-modals__images .dbtfy-option-modal__image')[0]?.classList.remove(
          'hidden'
        );
        this.querySelectorAll(
          '.dbtfy-product-option-modals__description .dbtfy-option-modal__description'
        )[0]?.classList.remove('hidden');
        this.querySelectorAll('.dbtfy-product-option-modals__title .dbtfy-option-modal__title')[0]?.classList.add(
          'active'
        );

        if (typeof Debutify.modal !== 'undefined') {
          this.initModal(option);
        } else {
          document.addEventListener('DOMContentLoaded', () => {
            setTimeout(() => {
              this.initModal(option);
            }, 500);
          });
        }
      }

      initModal(option) {
        const originalSelector =
  this.querySelector(`.dbtfy-product-option-modals__selector#${this.dataset.id}`) ||
  this.querySelector(`dbtfy-product-option-modals__selector#${this.dataset.id}`);
        if (!originalSelector) return;

        const clonedSelector = originalSelector.cloneNode(true);
        clonedSelector.id = `${this.dataset.id}-clone`;
        document.body.appendChild(clonedSelector);

        this.modal = new Debutify.modal({
          closeMethods: ['overlay', 'escape', 'button'],
          size: document.querySelector('.dbtfy-option-modal__content').dataset.modalWidth,
          closeIcon: 'close',
          selector: `#${clonedSelector.id}`,
          overlayClass: ['dbtfy-option-modal-content--overlay'],
          onOpen: function () {},
          onClose: function () {},
        });

        this.querySelector('.dbtfy-product-option-modal__value').addEventListener('click', () => {
          this.modal.open();

          this.modal.modalBox.querySelectorAll('.dbtfy-option-modal__title').forEach((title) => {
            title.addEventListener('click', (event) => {
              const target = event.target;
              const modal = target.closest('.dbtfy-option-modal-content--overlay');

              if (!modal) return;

              modal
                .querySelectorAll('.dbtfy-product-option-modals__images .dbtfy-option-modal__image')
                .forEach((img) => img.classList.add('hidden'));

              modal
                .querySelectorAll('.dbtfy-product-option-modals__description .dbtfy-option-modal__description')
                .forEach((desc) => desc.classList.add('hidden'));

              const id = target.id;

              modal
                .querySelector(`.dbtfy-product-option-modals__images .dbtfy-option-modal__image#${id}`)
                ?.classList.remove('hidden');

              modal
                .querySelector(`.dbtfy-product-option-modals__description .dbtfy-option-modal__description#${id}`)
                ?.classList.remove('hidden');

              modal.querySelectorAll('.dbtfy-option-modal__title').forEach((t) => t.classList.remove('active'));
              target.classList.add('active');
            });
          });
        });
      }
    }
  );
}
